import CurrentUserAction, {
  BENCHMARK_ENGINEER_LINKED_TYPE,
  BENCHMARK_ENGINEER_UNLINKED_TYPE,
  CURRENT_USER_CHANGE_PASSWORD_FAILURE_TYPE,
  CURRENT_USER_CHANGE_PASSWORD_TYPE,
  CURRENT_USER_LOADED_TYPE,
  CURRENT_USER_LOAD_ERROR_TYPE,
  CURRENT_USER_PASSWORD_CHANGED_TYPE,
  CURRENT_USER_UPDATED_TYPE,
  CURRENT_USER_UPDATE_ERROR_TYPE,
  LOAD_CURRENT_USER_TYPE,
  LINK_BENCHMARK_ENGINEER_ERROR_TYPE,
  LINK_BENCHMARK_ENGINEER_TYPE,
  UNLINK_BENCHMARK_ENGINEER_ERROR_TYPE,
  UNLINK_BENCHMARK_ENGINEER_TYPE,
} from "./CurrentUserAction";
import CurrentUserState from "./CurrentUserState";

const initialState: CurrentUserState = {
  user: undefined,
  isLoading: false,
  error: undefined,
  success: undefined,
};

const currentUserReducer = (
  state = initialState,
  action: CurrentUserAction
): CurrentUserState => {
  switch (action.type) {
    case LOAD_CURRENT_USER_TYPE:
      return {
        user: undefined,
        isLoading: true,
        error: undefined,
        success: undefined,
      };
    case CURRENT_USER_LOADED_TYPE:
      return {
        user: action.user,
        isLoading: false,
        error: undefined,
        success: state.success,
      };
    case CURRENT_USER_LOAD_ERROR_TYPE:
      return {
        user: undefined,
        isLoading: false,
        error: action.error,
        success: undefined,
      };
    case CURRENT_USER_UPDATED_TYPE:
      return {
        user: action.user,
        isLoading: true,
        error: undefined,
        success: undefined,
      };
    case CURRENT_USER_CHANGE_PASSWORD_TYPE:
      return {
        user: state.user,
        isLoading: true,
        error: undefined,
        success: undefined,
      };
    case CURRENT_USER_CHANGE_PASSWORD_FAILURE_TYPE:
      return {
        user: state.user,
        isLoading: false,
        error: action.error,
        success: undefined,
      };
    case CURRENT_USER_UPDATE_ERROR_TYPE:
      return {
        user: state.user,
        isLoading: false,
        error: action.error,
        success: undefined,
      };
    case CURRENT_USER_PASSWORD_CHANGED_TYPE:
      return {
        user: state.user,
        isLoading: false,
        error: undefined,
        success: action.success,
      };
    
    case LINK_BENCHMARK_ENGINEER_TYPE:
    case UNLINK_BENCHMARK_ENGINEER_TYPE:
      return {
        ...state,
        isLoading: true,
        error: undefined,
        success: undefined,
      };

    case BENCHMARK_ENGINEER_LINKED_TYPE:
      return {
        ...state,
        user: action.user,
        isLoading: false,
        error: undefined,
        success: "benchmarkAccountPanel.linkSuccess",
      };

    case BENCHMARK_ENGINEER_UNLINKED_TYPE:
      return {
        ...state,
        user: action.user,
        isLoading: false,
        error: undefined,
        success: "benchmarkAccountPanel.unlinkSuccess",
      };

    case LINK_BENCHMARK_ENGINEER_ERROR_TYPE:
    case UNLINK_BENCHMARK_ENGINEER_ERROR_TYPE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        success: undefined,
      };

    default:
      return state;
  }
};

export default currentUserReducer;
